import { NicheFields, NicheFieldsNames } from "@/components/popups/NicheForm/NicheForm";

export const INITIAL_STEP = "INITIAL_STEP";
export const CREATE_STEP = "CREATE_STEP";
export const SUCCESS_STEP = "SUCCESS_STEP";
export const DUPLICATE_CODE = "DuplicateNiche";

export const CREATE_NICHE_FIELDS: { [key in NicheFieldsNames]: NicheFields } = {
  [NicheFieldsNames.name]: {
    id: "name",
    label: "Name",
    placeholder: "Give your Niche a name.",
    validation: {
      required: "Your Niche name must be unique.",
    },
    type: "text",
    defaultValue: ""
  },
  [NicheFieldsNames.description]: {
    id: "description",
    label: "Description",
    placeholder: "What kind of content will your Niche feature? Niches with clear, detailed descriptions perform better.",
    validation: {
      required: "Let other users know what this Niche is about.",
      minLength: { value: 30, message: "Longer descriptions help other users (min 30 characters)" }
    },
    rows: 4,
    defaultValue: ""
  }
};
